module.exports = __webpack_public_path__ + "img/package-2.cd909b89.png";